import { Dialog } from '@myosh/odin-components'
import type { GapAnalysisViewDto, TrainingMatrixViewDto } from '../../../API/rtk-query-api/store/tmsApi'
import Notifications from '../notifications/Notifications'
import ViewNameEditor from './view-name-editor'

const dialogId = 'manage-views-dialog'
export const manageViewsToasterId = 'manage-views'

interface ViewManagementModalProps {
  isModalVisible: boolean
  viewsToManage: Array<TrainingMatrixViewDto | GapAnalysisViewDto>
  onRemoveView: (view: TrainingMatrixViewDto | GapAnalysisViewDto) => void
  onRenameView: (view: TrainingMatrixViewDto | GapAnalysisViewDto) => void
  onHideModal: () => void
}

function ViewManagementModal({
  isModalVisible,
  viewsToManage,
  onRemoveView,
  onHideModal,
  onRenameView
}: ViewManagementModalProps) {
  const handleViewRename = (view: TrainingMatrixViewDto | GapAnalysisViewDto) => {
    onRenameView(view)
  }

  const handleRemoveView = (view: TrainingMatrixViewDto | GapAnalysisViewDto) => {
    onRemoveView(view)
  }

  return (
    <>
      {isModalVisible && (
        <Dialog id={dialogId} header='Manage Views' visible={isModalVisible} onClose={onHideModal}>
          {viewsToManage.map((view, index) => {
            return (
              <ViewNameEditor
                key={view.id}
                view={view}
                isEven={index % 2 === 0}
                onChange={handleViewRename}
                onRemove={handleRemoveView}
              />
            )
          })}
          <Notifications
            appendTo={document.getElementById(dialogId) ?? document.body}
            toasterId={manageViewsToasterId}
          />
        </Dialog>
      )}
    </>
  )
}

export default ViewManagementModal
